export let IntroVideoType = /*#__PURE__*/function (IntroVideoType) {
  IntroVideoType["None"] = "none";
  IntroVideoType["VideoLink"] = "videoLink";
  return IntroVideoType;
}({});